import { UseControllerProps } from 'react-hook-form';

export const PHONE_NUMBER_RULE: UseControllerProps['rules'] = {
  pattern: {
    value: /^[0-9]{8}$/,
    message: 'شماره تلفن ثابت نامعتبر است',
  },
};
